import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import customers from './Customers'
import orders from './Orders'
import products from './Products'
import subscriptions from './Subscriptions'
import ui from './UI'
import security from './Security'
import general from './General'
import admin from './Admin/General'
import resellers from './Admin/Resellers'
import roles from './Admin/Roles'
import users from './Admin/Users'
import productsAdmin from './Admin/Products'
import vendors from './Admin/Vendors'
import userProfile from './Settings/UserProfile'
import resellerProfile from './Settings/ResellerProfile'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    customers: customers,
    orders: orders,
    products: products,
    subscriptions: subscriptions,
    ui: ui,
    security: security,
    admin: admin,
    general: general,
    resellers: resellers,
    roles: roles,
    users: users,
    productsAdmin: productsAdmin,
    vendors: vendors,
    userProfile: userProfile,
    resellerProfile: resellerProfile,
  },
})
